const getSearchStringFromFilterOptions = (item, field, excludedSearchAttr) => {
    if (!item) {
        return '';
    }

    const excludedAttr = excludedSearchAttr || [];
    const filteredField = item[field].filter(option => !excludedAttr.includes(option.code));
    let searchString = '';

    filteredField.forEach(option => {
        if (option.values && Array.isArray(option.values)) {
            searchString += ` ${option.values.join(' ').toLowerCase()}`;
        }
    });

    // replace attribute's separator '||' with white space
    searchString = searchString.replace(/\|\|/g, ' ');

    return searchString;
};

export default getSearchStringFromFilterOptions;
